import script from "./ArtefactDashboardStrategies.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtefactDashboardStrategies.vue?vue&type=script&setup=true&lang=ts"

import "./ArtefactDashboardStrategies.vue?vue&type=style&index=0&id=155562d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155562d9"]])

export default __exports__